import { render } from "./App.vue?vue&type=template&id=a376669a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a376669a&lang=css"

import exportComponent from "D:\\projectLinkoffer\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__